import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Filter } from '../models/filter';
import { ReceiptFilter } from '../models/filters/receipt-filter';
import { Paging } from '../models/page';
import { Receipt } from '../models/receipt';
import { ResponseModel } from '../models/response-model';

@Injectable({
  providedIn: 'root'
})
export class ReceiptsService {
  url: string = `${environment.url}/receipts`
  constructor(private http: HttpClient) { }

  readReceipts(filter: Filter<ReceiptFilter>) {
    let params = new HttpParams();
    params = params
      .set("page", filter.page.toString() || "0")
      .set("pageSize", filter.pageSize.toString() || "20");
    params = filter.value.code ? params.set("code", filter.value.code) : params;
    params = filter.value.contractNumber ? params.set("contractNumber", filter.value.contractNumber) : params;
    return this.http.get<ResponseModel<Paging<Array<Receipt>>>>(`${this.url}`, { params });
  }
}
